
















import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class ShunFengPrint extends Vue {
  pictureKey = [];
  mounted() {
    let key: any = this.$route.query.key;
    this.pictureKey = key.split(',');
  }

  profileUrl(key: string) {
    if (key) {
      return `${process.env.VUE_APP_FILE_URL}/sf_print/${key}`;
    } else {
      return '';
    }
  }

  /**点击了弹窗里面的打印 */
  onConfimPrintClick() {
    // console.log((this.$refs.printDiv as Element).innerHTML);
    let content: string = this.generateHtml();
    let iframe = document.createElement('iframe');
    iframe.id = 'printIframe';
    let f = document.body.appendChild(iframe);
    let w = (f.contentWindow || f.contentDocument) as Window;
    let doc = f.contentDocument || f.contentWindow!.document;
    doc.open();
    doc.write(content);
    doc.close();
    iframe.onload = function() {
      w.focus();
      try {
        if (!w.document.execCommand('print', false)) {
          w.print();
        }
      } catch (e) {
        w.print();
      }
      w.close();
      document.body.removeChild(iframe);
    };
  }

  generateHtml(): string {
    let content: string = (this.$refs.printDiv as Element).innerHTML;
    let html = `<head><style>body{margin:0;padding:0}img{width:100%;height:100%}</style><style>@media print { body { margin: 0; padding: 0; } .page-break { page-break-before: always; }}</style></head><body>${content}</body>`;
    console.log(html);
    return html;
  }

  /**点击了关闭按钮 */
  onCloseClick() {
    window.close();
  }
}
